import {FullHeightProductTileBase} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {ProductTile, ProductTileProps} from './ProductTile';

export const FullHeightHoverImageProductTile: React.FC<
  Omit<ProductTileProps, 'ProductTileComponent' | 'enableHoverImageSwap'>
> = props => {
  return (
    <StyledProductTile
      {...props}
      ProductTileComponent={FullHeightProductTileBase}
      enableHoverImageSwap
    />
  );
};

const StyledProductTile = styled(ProductTile)`
  height: 100%;
  height: stretch;
`;
